/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import Autocomplete from 'react-autocomplete';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as transactionService from '../services/transactionService'
import * as userService from '../services/userService'
import Currency from './sub_components/currency'
import "react-datetime/css/react-datetime.css";
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import * as _ from 'lodash'
import { BASE_IMAGE_PATH, BASE_IMAGE_PATH_NEW } from '../configs/api';
let printClickTimeout
let linkClickTimeout
class SettlementReport extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            user_id: '',
            usersList: [],
            client_id: "",
            searched_client: "",
            transaction_type: "settlement",
            settlement_balance_data: [],
            settlement_balance_search_data: [],
            csv_json: [],
            pdf_json: [],
            loader: false,
            showData: false,
            from: "",
            to: "",
            dataType: 'ALL',

            pageLimit: 25,
            pageActive: 1,
            page_no: 1, 
            ePnL_data: [],
            allData: false,
        
        };
    }

    async componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            localStorage.clear();
            this.props.history.push("/auth")
        }
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ user_id: userData.sub, to: curDate, from: weekDate },
            () => {
                // this.submitForm()
            }
        )
    }
    componentWillUnmount(){
        clearTimeout(linkClickTimeout)
        clearTimeout(printClickTimeout)
    }

    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }

    parseFilterBody() {
        // let body = {
        //     "user_id": this.state.user_id,
        //     "client_id": this.state.client_id, 
        //     "transaction_type": this.state.transaction_type
        // }
        let body = {
            "userId": this.state.client_id,
            "transactionType": this.state.transaction_type,
            "from": new Date(this.state.from).toISOString(),
            "to": new Date(this.state.to).toISOString(),
            "type": this.state.dataType
        };
        body = this.clean(body);
        return body
    }

    async submitForm() {
        const self = this;
        let body = this.parseFilterBody()
        this.setState({ showData: false, loader: true })
        transactionService.postSettlementReport(body).then((res) => {
            if (res.isSuccess) {
                self.setState(
                    {
                        settlement_balance_data: [],
                        settlement_balance_search_data: [],
                    }, () => {
                        self.setState({
                            settlement_balance_data: res.items,
                            settlement_balance_search_data: res.items,
                            showData: true,
                            loader: false
                        })
                    }
                );
            } else {
                this.props.notify(res.message, "error")
                this.setState({ settlement_balance_data: [], settlement_balance_search_data: [], showData: true, loader: false })
            }
        })
    }
    onSubmit(e) {
        let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 31) {
           this.props.notify("Date range must be 1 month.", "error");
        }
        else {
           this.setState({ action: "", page_no: 1, pageActive: 1, accounts: this.state.client_id, opening_balance: 0, hst_balance: [], first_id: "" }, () => { this.submitForm(); });
        }
     }

    async onDownload(alldata = false) {
        const self = this;
        this.setState({ csv_json: [] }, () => {
            let trans = this.state.settlement_balance_search_data
            let dictinory = {}
            let items = []
            let i = 0
            let closingBalance = 0
            let filter_user_id = !!this.state.client_id ? this.state.client_id : this.state.user_id
            items.push(dictinory)
            for (let x of trans) {
              if (alldata ? true : (i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))){ 

                dictinory = {}
                let st = x["createdAt"].split(" ")
                let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                let dt = new Date(dtstr).toLocaleString("hi-IN")
                let debitAccount = x["debitAccount"]
                let creditAccount = x["creditAccount"]
                let curr_user = !!this.state.client_id ? this.state.client_id : this.state.user_id
                
                dictinory["Date & Time"] = dt
                
                if (x["creditAccount"] === filter_user_id) {
                    dictinory["Credit"] = x["amount"]
                    dictinory["Debit"] = "-"
                }
                if (x["debitAccount"] === filter_user_id) {
                    dictinory["Credit"] = "-"
                    dictinory["Debit"] = x["amount"]
                }

                if ( x["type"] === "DEPOSIT") {
                    if (creditAccount === "CASH_" + curr_user) {
                        creditAccount = x["tags"][0]
                        closingBalance += x["amount"]
                    }
                    if (debitAccount === "CASH_" + curr_user) {
                        debitAccount = x["tags"][0]
                        closingBalance -= x["amount"]
                    }
                    if (creditAccount === curr_user) {
                        closingBalance += x["amount"]
                    }
                    if (debitAccount === curr_user) {
                        closingBalance -= x["amount"]
                    }
                }else{
                    if (creditAccount === curr_user) {
                        closingBalance += x["amount"]
                    }
                    if (debitAccount === curr_user) {
                        closingBalance -= x["amount"]
                    }
                }
                dictinory["Closing"] = closingBalance

                dictinory["Description"] = x["description"]
                if (x["type"] !== "BALANCE" && x["type"] !== "COMMISSION") {
                    if (x["creditAccount"] === "CASH_" + filter_user_id) {
                        let creditAccount = x["tags"][0]
                        dictinory["From → To"] = x["debitAccount"] + " → " + creditAccount
                    }
                    else if (x["debitAccount"] === "CASH_" + filter_user_id) {
                        let debitAccount = x["tags"][0]
                        dictinory["From → To"] = debitAccount + " → " + x["creditAccount"]
                    }
                    else {
                        dictinory["From → To"] = x["debitAccount"] + " → " + x["creditAccount"]
                    }
                }
                else {
                    dictinory["From → To"] = ""
                }
                items.push(dictinory)

               }
               i += 1
            }
            this.setState({ csv_json: items }, () => {
                linkClickTimeout = setTimeout(function () {
                    self.csvLink.current.link.click();
                }, 500)

            })
        })
    }

    async onPDFDownload(allData = false) {
        this.setState({ pdf_json: [] }, () => {
            this.setState({ pdf_json: this.state.settlement_balance_search_data,  allData: allData }, () => {
                printClickTimeout = setTimeout(function () {
                    printJS({
                        printable: 'printJS-div',
                        type: 'html',
                        targetStyles: ['*']
                    })
                }, 500)
            })
        })
    }

    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        // this.setState({ [name]: value, client_id: "", usersList: [], searched_client: "", settlement_balance_data: [], settlement_balance_search_data: [] },
        //     () => {
        //         this.submitForm()
        //     }
        // );
        this.setState({ [name]: value, pageActive: 1});
    }

    async onUserSearch(e, name, value) {
        if (value.length > 1) {
            this.setState({ [name]: value })
            let res = await userService.getUserSearch(this.state.user_id, value)
            let lst = []
            for (let x of res.usersList) {
                lst.push({ label: x, value: x, title: x, name: x })
            }
            lst.sort(function(a, b) {
                if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
                if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
                return 0;
            });
            this.setState({ usersList: lst })
        }
        else if (value === "") {
            this.setState({ [name]: value, usersList: [], client_id: "" },
                () => {
                    //this.submitForm()
                }
            )
        }
        else {
            this.setState({ [name]: value, usersList: [] })
        }
    }

    async onSelectedUser(searched_client) {

        this.setState({ searched_client: "", client_id: "" },
            () => {
                this.setState({ client_id: searched_client, searched_client: searched_client },
                    () => {
                        //this.submitForm()
                    }
                )
            }
        )
    }
    
    onSearch(e) {
        const value = e.target.value;
        let settlement_lst = []
        if (this.state.settlement_balance_search_data) {
            settlement_lst = _.filter(this.state.settlement_balance_search_data, function (obj) {
                return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            this.setState({ settlement_balance_data: [], pageActive: 1 }, () => {
                this.setState({ settlement_balance_data: settlement_lst })
            });
        };
    }


    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
  
    resetForm() {
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ user_id: "", client_id: "", dataType: 'ALL', user_list: [], showData: false, from: weekDate, to: curDate, settlement_balance_data: [], settlement_balance_search_data: [], transaction_type: "settlement"})
    }

    onAction(e) {
        const name = e.target.name;
        if (name === "first") {
           this.setState({ pageActive: 1 })
        } else if (name === "prev") {
           this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }) ) 
        } else if (name === "next") {
           this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }) )
        } else if (name === "last") {
           this.setState({ action: name }, this.setState({ pageActive: Math.ceil(this.state.settlement_balance_data.length / this.state.pageLimit)}) ) 
        } 
     }

    render() {
        let curr_user = !!this.state.client_id ? this.state.client_id : this.state.user_id
        let closingBalance = 0
        let pdfClosingBalance = 0

        let lst = []
        let total_page = Math.ceil( this.state.settlement_balance_data.length/ this.state.pageLimit)
        for (let x = 1; x <= total_page; x++) {
           if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
              let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => {{ this.onAction(e) } this.setState({ pageActive: x })}}>{x} </button>
              lst.push(htm)
           }
        }

        return (
            <>
                <div className="bethubs">
                    <Header history = {this.props.history} />
                    <div className="wrapper">
                        <div className="container-fluid container-padding-0">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="main-box">
                                        <h5 className="text-blue">Settlement/Balance Transaction Report</h5>
                                        {/* <div className="row mt-3">
                                            <div className="col-12 form-check">
                                                {/* <input type="radio" className="" name="transaction_type" value="settlement" checked={this.state.transaction_type === "settlement"} onChange={(e)=>{ this.onChange(e) }} /> Settlement Transactions &nbsp;&nbsp;&nbsp;&nbsp;
                                                <input type="radio" className="" name="transaction_type" value="balance" checked={this.state.transaction_type === "balance"} onChange={(e)=>{ this.onChange(e) }} /> Balance Transactions *}
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="settlement" name="transaction_type" value="settlement" checked={this.state.transaction_type === "settlement"} onChange={(e) => { this.onChange(e) }} />
                                                    <label className="form-check-label text-dark" for="settlement">
                                                        Settlement Transactions
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="balance" name="transaction_type" value="balance" checked={this.state.transaction_type === "balance"} onChange={(e) => { this.onChange(e) }} />
                                                    <label className="form-check-label text-dark" for="balance">
                                                        Balance Transactions
                                                    </label>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="row mt-2">
                                            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                                <div className="form-group font-12">
                                                    <select title="Transaction Type" className="form-control" name="transaction_type" value={this.state.transaction_type} onChange={(e) => { this.onChange(e) }}>
                                                    <option value="settlement">Settlement Transactions</option>
                                                    <option value="balance">Balance Transactions</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                                <div className="form-group font-12">
                                                    <select title="Data Type" className="form-control" name="dataType" value={this.state.dataType} onChange={(e) => { this.onChange(e) }}>
                                                    <option value="ALL">All</option>
                                                    <option value="CREDIT">Credit</option>
                                                    <option value="DEBIT">Debit</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                                <div className="form-group font-12 autocomplete-wrapper">
                                                    <Autocomplete
                                                        value={this.state.searched_client}
                                                        items={this.state.usersList}
                                                        getItemValue={item => item.title}
                                                        renderItem={(item, isHighlighted) =>
                                                            <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                                                {item.title}
                                                            </div>
                                                        }
                                                        inputProps={{ placeholder: 'Search by client' }}
                                                        name="searched_client"
                                                        onChange={(event, searched_client) => this.onUserSearch(event, "searched_client", searched_client)}
                                                        onSelect={searched_client => this.onSelectedUser(searched_client)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                                <div className="form-group font-12">
                                                    <Datetime
                                                    value={this.state.from}
                                                    onChange={(e) => this.onDateTimeChange("from", e)}
                                                    id="from_datetime"
                                                    dateFormat={"DD/MM/YYYY"}
                                                    timeFormat={"HH:mm"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                                <div className="form-group font-12">
                                                    <Datetime
                                                    value={this.state.to}
                                                    onChange={(e) => this.onDateTimeChange("to", e)}
                                                    id="to_datetime"
                                                    dateFormat={"DD/MM/YYYY"}
                                                    timeFormat={"HH:mm"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                                <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                                    <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}><img alt="" style={{width: "45px"}} src={BASE_IMAGE_PATH + "/aimg/loader.gif"}></img></div> : null} */}
                                        {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2 text-center w-100"}>
                                            <div className="spinner-border text-info" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div> : null}
                                        {!!this.state.showData && <div>

                                            <div className="row text-center mt-2">
                                                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 mt-4 order-md-1 order-sm-2 order-2">
                                                    <div className="d-flex float-left">
                                                        <div className="form-group mb-0 d-inline">
                                                            <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                                        </div>
                                                        <CSVLink
                                                            data={this.state.csv_json}
                                                            filename={this.state.transaction_type+"-Report.csv"}
                                                            asyncOnClick={true}
                                                            className="d-none"
                                                            ref={this.csvLink}>
                                                        </CSVLink>
                                                        <button className="btn btn-sm csv-icon d-inline p-0" title="Export Data" onClick={(e) => this.onDownload(false)} disabled={this.state.settlement_balance_data.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                                        <div style={{ display: "none" }}>
                                                            <div id="printJS-div">
                                                                <table id="exportall" className="table font-12 table-bordered table-sm" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px' }} >
                                                                    <thead >
                                                                        <tr>
                                                                            <th className="text-left pthead rw-150">Date &amp; Time</th>
                                                                            <th className="text-right pthead rw-80">Credit</th>
                                                                            <th className="text-right pthead rw-80">Debit</th>
                                                                            <th className="text-right pthead rw-80">Closing</th>
                                                                            <th className="text-left pthead">Description</th>
                                                                            <th className="text-left pthead">From &#8594; To</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.pdf_json.length > 0 ? this.state.pdf_json.map((user, i) => {
                                                                            let st = (user.createdAt).split(" ")
                                                                            let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                                            let dt = new Date(dtstr).toLocaleString("hi-IN")
                                                                            let debitAccount = user.debitAccount
                                                                            let creditAccount = user.creditAccount
                                                                            if (user.type === "DEPOSIT") {
                                                                                if (creditAccount === "CASH_" + curr_user) {
                                                                                    creditAccount = user.tags[0]
                                                                                    pdfClosingBalance += user.amount
                                                                                }
                                                                                if (debitAccount === "CASH_" + curr_user) {
                                                                                    debitAccount = user.tags[0]
                                                                                    pdfClosingBalance -= user.amount
                                                                                }
                                                                                if (creditAccount === curr_user) {
                                                                                    pdfClosingBalance += user.amount
                                                                                }
                                                                                if (debitAccount === curr_user) {
                                                                                    pdfClosingBalance -= user.amount
                                                                                }
                                                                            }else{
                                                                                if (creditAccount === curr_user) {
                                                                                    pdfClosingBalance += user.amount
                                                                                }
                                                                                if (debitAccount === curr_user) {
                                                                                    pdfClosingBalance -= user.amount
                                                                                }
                                                                            }
                                                                            return (<>
                                                                                {this.state.allData ? 
                                                                                  
                                                                                    <tr key={"accstate_tr_set" + i} bgcolor="#ffffff">
                                                                                       <td className="text-left" title={dt ? dt : "-"}>{dt ? dt : "-"}</td>
                                                                                       <td className="text-right">{creditAccount === curr_user ? <Currency key={"accstate_creset_" + i} className="fbold text-green" amount={user.amount} showColor={false} /> : "-"}</td>
                                                                                       <td className="text-right">{debitAccount === curr_user ? <Currency key={"accstateset_deb_" + i} className="fbold text-red" amount={user.amount} showColor={false} /> : "-"}</td>
                                                                                       <td className="text-right">{!!pdfClosingBalance ? <Currency key={"accstateset_deb_clo" + i} className="fbold" amount={pdfClosingBalance} showColor={true} /> : "-"}</td>
                                                                                       <td className="text-left" title={user.description}>{!!user.description ? user.description : "-"}</td>
                                                                                       <td className="text-left">{user.type !== "BALANCE" && user.type !== "COMMISSION" ? <>{!!debitAccount ? debitAccount : "-"} &#8594; {!!creditAccount ? creditAccount : "-"}</> : ""}</td>
                                                                                   </tr>
                                                                                
                                                                                 : i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) &&
                                                                                <tr key={"accstate_tr_set" + i} bgcolor="#ffffff">
                                                                                    <td className="text-left" title={dt ? dt : "-"}>{dt ? dt : "-"}</td>
                                                                                    <td className="text-right">{creditAccount === curr_user ? <Currency key={"accstate_creset_" + i} className="fbold text-green" amount={user.amount} showColor={false} /> : "-"}</td>
                                                                                    <td className="text-right">{debitAccount === curr_user ? <Currency key={"accstateset_deb_" + i} className="fbold text-red" amount={user.amount} showColor={false} /> : "-"}</td>
                                                                                    <td className="text-right">{!!pdfClosingBalance ? <Currency key={"accstateset_deb_clo" + i} className="fbold" amount={pdfClosingBalance} showColor={true} /> : "-"}</td>
                                                                                    <td className="text-left" title={user.description}>{!!user.description ? user.description : "-"}</td>
                                                                                    <td className="text-left">{user.type !== "BALANCE" && user.type !== "COMMISSION" ? <>{!!debitAccount ? debitAccount : "-"} &#8594; {!!creditAccount ? creditAccount : "-"}</> : ""}</td>
                                                                                </tr>
                                                                                  }
                                                                                </>
                                                                            );
                                                                        }) : <tr>
                                                                            <td colSpan={15} align="center">
                                                                                No Data Found.
                                                                            </td>
                                                                        </tr>}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(false)} disabled={this.state.settlement_balance_data.length > 0 ? false : true}>
                                                            <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                                        </button>
                                                        <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(true)} disabled={this.state.settlement_balance_data.length > 0 ? false : true}>
                                                           <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img>
                                                        </button>
                                                        <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(true)} disabled={this.state.settlement_balance_data.length > 0 ? false : true}>
                                                            <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-4 order-md-1 order-sm-2 order-2">
                                                   <span className="d-inline search-report"> &nbsp; entries </span>
                                                   <div className="form-group font-12 float-right mb-0">
                                                        <select onKeyPress={(e) => this.onAction(e)} onChange={(e) => { this.onChange(e) }} className="form-control" name="pageLimit" value={this.state.pageLimit}>
                                                           <option value="25">25</option>
                                                           <option value="50">50</option>
                                                           <option value="100">100</option>
                                                           <option value="200">200</option>
                                                           <option value="500">500</option>
                                                        </select>
                                                   </div>
                                                   <span className="d-inline search-report mr-2">Show</span>
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div className="table-responsive">
                                                        <table id="example" className="table font-12 table-bordered table-sm addpadding table-striped mt-2">
                                                            <thead>
                                                                <tr>
                                                                    <th className="pthead">Date &amp; Time</th>
                                                                    <th className="text-right pthead rw-80">Credit</th>
                                                                    <th className="text-right pthead rw-80">Debit</th>
                                                                    <th className="text-right pthead rw-80">Closing</th>
                                                                    <th className="pthead">Description</th>
                                                                    <th className="pthead">From &#8594; To</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.settlement_balance_data.length > 0 ? this.state.settlement_balance_data.map((user, i) => {
                                                                    let st = (user.createdAt).split(" ")
                                                                    let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                                    let dt = new Date(dtstr).toLocaleString("hi-IN")
                                                                    let debitAccount = user.debitAccount
                                                                    let creditAccount = user.creditAccount
                                                                    if (user.type === "DEPOSIT") {
                                                                        if (creditAccount === "CASH_" + curr_user) {
                                                                            creditAccount = user.tags[0]
                                                                            closingBalance += user.amount
                                                                        }
                                                                        if (debitAccount === "CASH_" + curr_user) {
                                                                            debitAccount = user.tags[0]
                                                                            closingBalance -= user.amount
                                                                        }
                                                                        if (creditAccount === curr_user) {
                                                                            closingBalance += user.amount
                                                                        }
                                                                        if (debitAccount === curr_user) {
                                                                            closingBalance -= user.amount
                                                                        }
                                                                    }else{
                                                                        if (creditAccount === curr_user) {
                                                                            closingBalance += user.amount
                                                                        }
                                                                        if (debitAccount === curr_user) {
                                                                            closingBalance -= user.amount
                                                                        }
                                                                    }
                                                                    return (<>
                                                                        {i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) &&
                                                                        <tr key={"accstatepd_tr_set" + i}>
                                                                            <td title={dt ? dt : "-"}>{dt ? dt : "-"}</td>
                                                                            <td className="text-right">{creditAccount === curr_user ? <Currency key={"accstate_creset_" + i} className="fbold text-green" amount={user.amount} showColor={false} /> : "-"}</td>
                                                                            <td className="text-right">{debitAccount === curr_user ? <Currency key={"accstateset_deb_" + i} className="fbold text-red" amount={user.amount} showColor={false} /> : "-"}</td>
                                                                            <td className="text-right">{!!closingBalance ? <Currency key={"accstateset_deb_clos" + i} className="fbold" amount={closingBalance} showColor={true} /> : "-"}</td>
                                                                            <td title={user.description}>{!!user.description ? user.description : "-"}</td>
                                                                            <td>{user.type !== "BALANCE" && user.type !== "COMMISSION" ? <>{!!debitAccount ? debitAccount : "-"} &#8594; {!!creditAccount ? creditAccount : "-"}</> : ""}</td>
                                                                        </tr>
                                                                         }
                                                                        </>
                                                                    );
                                                                }) : <tr>
                                                                    <td colSpan={15} align="center">
                                                                        No Data Found.
                                                                        </td>
                                                                </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                                                </div>
                                            </div>
                                        </div>}

                                       { 
                                        this.state.settlement_balance_data.length > 0 &&
                                             <>       
                                                <div className="row">
                                                   <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) <  this.state.settlement_balance_data.length ? (this.state.pageLimit * this.state.pageActive) :  this.state.settlement_balance_data.length} of { this.state.settlement_balance_data.length} entries</span></div>
                                                   <div className="col-12 col-sm-12 col-md-6">
                                                      <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                                         <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                                         <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                                         {lst}  
                                                         <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil( this.state.settlement_balance_data.length / this.state.pageLimit)? true : false}>Next</button>
                                                         <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil( this.state.settlement_balance_data.length / this.state.pageLimit)? true : false}>Last</button>
                                                      </div>
                                                   </div>
                                                </div>
                                             </>
                                          }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SettlementReport);